import { observer } from "mobx-react-lite";
import { FormEvent, useState } from "react";
import { useAppContext } from "../../../../shared/functions/Context";
import { hideModalFromId } from "../../../../shared/functions/ModalShow";
import MODAL_NAMES from "../../../dialogs/ModalName";
import {
  IValue,
  defaultValue,
} from "../../../../shared/models/three-sixty-feedback-models/Values";

const NewValueModal = observer(() => {
  const { api, store } = useAppContext();
  const me = store.auth.meJson;
  const [value, setValue] = useState<IValue>(defaultValue);
  const [loading, setLoading] = useState(false);
  const [statements, setStatements] = useState<
    { id: string; statement: string }[]
  >([
    { id: "1", statement: "" }, // Fixed ID for the first field
    { id: "2", statement: "" }, // Fixed ID for the second field
    { id: "3", statement: "" }, // Fixed ID for the third field
  ]);

  const handleStatementChange = (index: number, statement: string) => {
    const updatedStatements = [...statements];
    updatedStatements[index].statement = statement;
    setStatements(updatedStatements);
  };

  const addStatement = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const newStatement = {
      id: new Date().toISOString(), // Dynamic ID for new statements
      statement: "",
    };
    setStatements([...statements, newStatement]);
  };

  const deleteStatement = (index: number) => {
    const updatedStatements = statements.filter((_, i) => i !== index);
    setStatements(updatedStatements);
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    const updatedValue: IValue = {
      ...value,
      statements: statements.map(({ statement }) => ({ statement, rating: 0 })),
    };

    if (!me) return;
    await create(updatedValue);
    console.log("Value, ", updatedValue);
    setLoading(false);
    onCancel();
  };

  const create = async (value: IValue) => {
    try {
      await api.value.create(value);
    } catch (error) {
      console.error("Error creating value:", error);
    }
  };

  const onCancel = () => {
    setValue({ ...defaultValue }); // Reset the value state to default
    setStatements([
      { id: "1", statement: "" }, // Fixed ID for the first field
      { id: "2", statement: "" }, // Fixed ID for the second field
      { id: "3", statement: "" }, // Fixed ID for the third field
    ]); // Reset the statements state to exactly three empty fields
    hideModalFromId(MODAL_NAMES.THREE_SIXTY_FEEDBACK.CREATE_VALUE_MODAL);
  };

  return (
    <div
      className="create-template-modal uk-modal-dialog uk-modal-body uk-margin-auto-vertical"
      data-uk-overflow-auto
    >
      <button
        className="uk-modal-close-default"
        type="button"
        data-uk-close
      ></button>
      <h3 className="uk-modal-title">New Value</h3>
      <div className="dialog-content uk-position-relative">
        <form onSubmit={handleSubmit}>
          <fieldset className="uk-fieldset">
            <div className="uk-margin">
              <input
                className="uk-margin"
                type="text"
                placeholder="New Value"
                value={value.valueName}
                onChange={(e) =>
                  setValue({ ...value, valueName: e.target.value })
                }
              />
            </div>

            <div className="dimension-view">
              <div className="uk-margin">
                {statements.map((statement, index) => (
                  <div
                    key={statement.id}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginBottom: "1rem",
                    }}
                  >
                    <input
                      className="uk-input uk-form-small"
                      type="text"
                      placeholder={`Enter Statement ${index + 1}`}
                      value={statement.statement}
                      onChange={(e) =>
                        handleStatementChange(index, e.target.value)
                      }
                    />
                    <button
                      className="delete-statement"
                      type="button"
                      onClick={() => deleteStatement(index)}
                      style={{ marginLeft: "1rem" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"></path>
                        <path d="M9 10h2v8H9zm4 0h2v8h-2z"></path>
                      </svg>
                    </button>
                  </div>
                ))}
              </div>

              <button
                className="add-statement"
                type="button"
                onClick={addStatement}
                disabled={!value.valueName.trim()}
              >
                Add Statement
              </button>
            </div>

            <div className="uk-width-1-1 uk-text-right">
              <button
                className="btn-text uk-margin-right"
                type="button"
                onClick={onCancel}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                type="submit"
                disabled={
                  !value.valueName.trim() ||
                  statements.some((s) => !s.statement.trim()) ||
                  loading
                }
              >
                Save {loading && <div data-uk-spinner="ratio: .5"></div>}
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  );
});

export default NewValueModal;
